import { render, staticRenderFns } from "./appointment-paid.vue?vue&type=template&id=a6971906&scoped=true&"
import script from "./appointment-paid.vue?vue&type=script&lang=js&"
export * from "./appointment-paid.vue?vue&type=script&lang=js&"
import style0 from "./appointment-paid.vue?vue&type=style&index=0&id=a6971906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6971906",
  null
  
)

export default component.exports